import { Component } from '@angular/core';
import { environment } from '../../environments/environment';
import { Dotcom2024Service } from '../dotcom2024.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MyharrellsService } from '../myharrells.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EventEmitter } from 'node:stream';
import * as XLSX from 'xlsx';
import { count } from 'node:console';
import { Subscription } from 'rxjs';
import { Meta, Title } from '@angular/platform-browser';
import { CanonicalService } from '../canonical.service';

@Component({
  selector: 'app-myharrells',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './myharrells.component.html',
  styleUrl: './myharrells.component.css'
})
export class MyharrellsComponent {
  appDomainURL: string = environment.appDomainURL;
  baseFilePath: string = environment.baseImagesFilePathBlobStorage;
  appAPIURLRoot: string = environment.appAPIUrlRoot;




  displaySuccessAlert: boolean = false;
  successText: string = "";
  displayFailureAlert: boolean = false;
  failureText: string = "";

  sortDir: string = "asc";
  sortDirCredits: string = "asc";

  imagefilePath = environment.azureBlobStorageURL + this.baseFilePath;
  myHarrellsLogoPath = environment.azureBlobStorageURL + this.baseFilePath + "/myHLogoBlack.png";
  excelFileLogoPath = environment.azureBlobStorageURL + this.baseFilePath + "/excel.png";

  customersListMaster: any[] = [];
  customersListFiltered: any[] = [];
  credits: any[] = [];
  showCustomersList: boolean = false;

  showAddressList: boolean = false;
  showFilterObjects: boolean = false;

  //array of the invoices displayed on the screen
  invoicesMaster: any[] = [];
  invoicesFiltered: any[] = [];
  invoicesItems: any[] = [];
  //arrays that populate the invoice filter dropdowns
  invoiceNumberMaster: any[] = [];
  invoiceNumberFiltered: any[] = [];
  showInvoiceNumberList: boolean = false;
  hasCredits: boolean = false;



  showInvoicePOList: boolean = false;

  invoicePOFiltered: any[] = [];
  invoicePOMaster: any[] = [];

  invoicesItemNumberMaster: any[] = [];
  invoicesItemNumberFiltered: any[] = [];
  showInvoicesItemNumbersList: boolean = false;
  invoicesClassListMaster: any[] = [];
  invoicesClassListFiltered: any[] = [];
  showInvoicesClassList: boolean = false;
  invoicesTypeListMaster: any[] = [];
  invoicesTypeListFiltered: any[] = [];
  showInvoicesTypeList: boolean = false;
  invoicesVendorListMaster: any[] = [];
  invoicesVendorListFiltered: any[] = [];
  showInvoicesVendorList: boolean = false;

  //array of the orders displayed on the screen
  openOrdersMaster: any[] = [];
  openOrdersFiltered: any[] = [];
  openOrdersItems: any[] = [];
  //arrays that populate the orders filter dropdowns
  ordersSOPNumberMaster: any[] = [];
  ordersSOPNumberFiltered: any[] = [];
  showOrdersSOPNumberList: boolean = false;
  ordersItemNumberMaster: any[] = [];
  ordersItemNumberFiltered: any[] = [];
  showOrdersItemNumberList: boolean = false;
  ordersClassesMaster: any[] = [];
  ordersClassesFiltered: any[] = [];
  showOrdersClassesList: boolean = false;
  ordersTypesMaster: any[] = [];
  ordersTypesFiltered: any[] = [];
  showOrdersTypesList: boolean = false;
  ordersVendorsMaster: any[] = [];
  ordersVendorsFiltered: any[] = [];
  showOrdersVendorsList: boolean = false;

  //array of the products displayed on the screen 
  myProductsMaster: any[] = [];
  myProductsFiltered: any[] = [];

  myProductsVendorSelected: string = "";
  showMyProductsVendorList: boolean = false;
  myProductsVendorListFiltered: any[] = [];
  myProductsVendorListMaster: any[] = [];
  myProductsClassSelected: string = "";
  showMyProductsClassList: boolean = false;
  myProductsClassListFiltered: any[] = [];
  myProductsClassListMaster: any[] = [];
  myProductsTypeSelected: string = "";
  showMyProductsTypeList: boolean = false;
  myProductsTypeListFiltered: any[] = [];
  myProductsTypeListMaster: any[] = [];
  selectedProduct: any = {};
  selectedMyProductRowId: string = ""; //this is the item number of the row selected since it is unique
  selectedProductsActiveIngredients: any[] = [];

  displayMyHarrellsMobileMenu: boolean = false;

  rep: any;

  headerBarTitle: string = "My Harrells";

  constructor(private title: Title, private meta: Meta, public dotComService: Dotcom2024Service, public myHarrellsService: MyharrellsService, public router: Router, public route: ActivatedRoute, private canonicalService: CanonicalService) { }

  ngOnInit() {


    //meta tags for SEO
    this.title.setTitle("MyHarrell’s Login | Manage Orders, Invoices & Rewards");
    this.meta.updateTag({ name: 'description', content: "MyHarrell’s is your online portal for invoices, deliveries, and rewards. Log in or request an account to streamline your Harrell’s experience." });
    this.meta.updateTag({ property: 'og:title', content: "MyHarrell’s Login | Manage Orders, Invoices & Rewards" });
    this.meta.updateTag({ property: 'og:description', content: "MyHarrell’s is your online portal for invoices, deliveries, and rewards. Log in or request an account to streamline your Harrell’s experience." });
    // this.meta.updateTag({ property: 'og:image', content: "og:image here - contacts" });
    // this.meta.updateTag({ property: 'og:url', content: "og:url here - contacts" });
    this.meta.updateTag({ property: 'Twitter:card', content: "MyHarrell’s Login | Manage Orders, Invoices & Rewards" });
    this.meta.updateTag({ property: 'Twitter:site', content: "MyHarrell’s Login | Manage Orders, Invoices & Rewards" });
    this.meta.updateTag({ property: 'Twitter:title', content: "MyHarrell’s Login | Manage Orders, Invoices & Rewards" });
    this.meta.updateTag({ property: 'Twitter:description', content: "MyHarrell’s is your online portal for invoices, deliveries, and rewards. Log in or request an account to streamline your Harrell’s experience." });
    // this.meta.updateTag({ property: 'Twitter:image', content: "twitter:image here - contacts" });
    // this.dotComService.createCanonicalURL();
    this.canonicalService.updateCanonicalURL(window.location.href);

    this.invoicesFiltered = [];

    //some customers get the online ordering link and some do not
    this.myHarrellsService.ShowOnlineOrderingLink(this.myHarrellsService.customerNmbrSelected).subscribe((data) => {
      if (data) {
        this.myHarrellsService.displayOnlineOrderingLink = true;
      }
      else {
        this.myHarrellsService.displayOnlineOrderingLink = false;
      }
    })

    if (this.myHarrellsService.loggedInMyHarrellsUser &&
      this.myHarrellsService.loggedInMyHarrellsUser.RoleName.indexOf('ClientBasic') == -1) {
      //the are a Client not a ClientBasic so start on invoices page 

      this.headerBarTitle = "Invoices"; //default title since we start off on the invoices page
      this.myHarrellsService.invoiceModeSelected = "Detail"; //default to detail view
      this.myHarrellsService.invoiceShowNonZeroOnlySelected = false; //default to show invoices that are not zero
      this.GetCustomersInvoices(); //since it is the default page we will get the invoices for the customer
    }
    else {
      //start on the open orders page because they only have client basic status
      this.headerBarTitle = "Open Orders"; //default title since we start off on the invoices page
      this.myHarrellsService.openOrdersBillHoldSelected = false; //default
      this.myHarrellsService.openOrdersModeSelected = "Detail"; //default to detail view
      this.GetCustomersOrders(); //since it is the default page we will get the invoices for the customer

    }

    //get all customers for this user
    this.customersListMaster = [];
    this.customersListFiltered = [];
    this.myHarrellsService.GetCustomersForThisUser().subscribe((data) => {
      this.myHarrellsService.addressesListMaster = data

      //get distinct list of customers in data and set customersListMaster 
      //this.customersListMaster = data

      //get a distinct list of customers from data 
      for (let i = 0; i < data.length; i++) {
        if (this.customersListMaster.findIndex(x => x.CustomerNumber == data[i].CustomerNumber) == -1) {
          this.customersListMaster.push(data[i]);
        }
        if (i == data.length - 1) {
          this.customersListMaster = this.customersListMaster.sort((a, b) => (a.Name > b.Name) ? 1 : -1)
          this.customersListFiltered = this.customersListMaster;
        }
      }
    })

    //get the rep details for use in the error message
    //use the logged in users email to get the rep details
    this.dotComService.GetRepInfoForUser().subscribe(reps => {
      if (reps.length > 0) {
        this.rep = reps[0];
      }
      else {
        this.rep = undefined;
      }
    })


  }

  ngOnDestroy(): void {
    this.canonicalService.updateCanonicalURL('');
  }



  //left panel 
  FilterCustomers() {
    this.customersListFiltered = this.customersListMaster.filter(x => x.Name.toLowerCase().indexOf(this.myHarrellsService.customerSelected.toLowerCase()) > -1 || x.CustomerNumber.toLowerCase().indexOf(this.myHarrellsService.customerSelected.toLowerCase()) > -1);
  }

  CustomerSelected(customer: any) {
    this.CloseAllInvoicesDropdowns();
    this.CloseAllOrdersDropdowns();
    this.CloseAllMyProductsDropdowns();

    this.myHarrellsService.customerAddressCodeSelected = "";

    this.myHarrellsService.customerSelected = customer.Name;
    this.myHarrellsService.customerNmbrSelected = customer.CustomerNumber;
    this.myHarrellsService.customerPORequired = customer.IsPORequired;

    sessionStorage.setItem('CustomerNumberSelected', customer.CustomerNumber);
    sessionStorage.setItem('CustomerNameSelected', customer.Name);
    sessionStorage.setItem('CustomerPORequired', customer.IsPORequired);

    this.showCustomersList = false;
    //fill the addresses for this customer 
    //this.myHarrellsService.addressesListMaster = [];
    this.myHarrellsService.addressSelected = "";
    this.myHarrellsService.GetThisUserCustomersAddresses(customer.CustomerNumber).subscribe((data) => {
      data.unshift({ Address1: "All Addresses", AddressId: "a" }); //add the All Addresses option to the top of the list
      this.myHarrellsService.addressesListFiltered = data;


      this.myHarrellsService.GetProductPartnerData(customer.CustomerNumber).subscribe((response) => {
        if (response && response.length > 0) {
          sessionStorage.setItem('PartnershipName', response[0].PartnershipName);
          sessionStorage.setItem('PartnershipId', response[0].PartnershipId);
        }
      })

      //some customers get the online ordering link and some do not
      this.myHarrellsService.ShowOnlineOrderingLink(customer.CustomerNumber).subscribe((data) => {
        if (data) {
          this.myHarrellsService.displayOnlineOrderingLink = true;
        }
        else {
          this.myHarrellsService.displayOnlineOrderingLink = false;
        }
      })

      //reload the display for the new customer selected
      if (this.headerBarTitle == 'Invoices') {
        this.myHarrellsService.invoicesTypeSelected = "";
        this.myHarrellsService.invoicesVendorSelected = "";
        this.myHarrellsService.invoicesClassSelected = "";
        this.myHarrellsService.invoicesItemNumberSelected = "";
        this.myHarrellsService.invoicesInvoiceNumberSelected = "";
        this.myHarrellsService.invoicesPOSelected = "";
        this.myHarrellsService.invoicesFromDate = undefined;
        this.myHarrellsService.invoicesToDate = undefined;

        this.GetCustomersInvoices().then(result => {
          this.GetCustomersCredits();
          this.GetInvoiceNumberMasterList();
          this.GetInvoicePOMasterList();
          this.GetItemNumberMasterList();
          this.GetClassMasterList();
          this.GetTypeMasterList();
          this.GetVendorMasterList();
          this.GetInvoicesDateRange();
        })
      }
      else if (this.headerBarTitle == 'Open Orders') {
        this.myHarrellsService.openOrdersBillHoldSelected = false; //default

        this.myHarrellsService.openOrdersModeSelected = "Detail"; //default

        this.myHarrellsService.ordersTypeSelected = "";
        this.myHarrellsService.ordersVendorSelected = "";
        this.myHarrellsService.ordersClassSelected = "";
        this.myHarrellsService.ordersItemNumberSelected = "";
        this.myHarrellsService.orderSOPNumberSelected = "";

        this.GetCustomersOrders().then(result => {
          this.GetOrdersOrderDD();
          this.GetOrdersItemNmbrDD();
          this.GetOrdersClassDD();
          this.GetOrdersTypeDD();
          this.GetOrdersVendorDD();
        })

      }
      else if (this.headerBarTitle == 'My Products') {
        this.LoadMyProducts();
      }
    })
  }

  GetInvoicesDateRange() {
    var earliest: Date = new Date("2500/12/30");
    var latest: Date = new Date("1900/01/01");

    for (let index = 0; index < this.invoicesFiltered.length; index++) {
      const element = this.invoicesFiltered[index];
      if (new Date(element.DocumentDate) < earliest) {
        earliest = new Date(element.DocumentDate);
      }
      if (new Date(element.DocumentDate) > latest) {
        latest = new Date(element.DocumentDate);
      }

      if (index == this.invoicesFiltered.length - 1) {
        //subtract one day from earliest 
        earliest.setDate(earliest.getDate() - 1); //it was not picking up invoices on the earliest date so we subtract one day

        this.myHarrellsService.invoicesFromDate = earliest
        this.myHarrellsService.invoicesToDate = latest;

        let x = new Date(earliest).toISOString().substring(0, 10);
        (<HTMLInputElement>document.getElementById('invoicesFromDate')).value = x;

        let y = new Date(latest).toISOString().substring(0, 10);
        (<HTMLInputElement>document.getElementById('invoicesToDate')).value = y;
      }
    }
  }

  CustomersFocus() {
    this.showCustomersList = true;
    this.customersListFiltered = this.customersListMaster;
    // this.myHarrellsService.customerSelected = "";
    // this.myHarrellsService.customerNmbrSelected = "";
    this.showAddressList = false;
  }

  FilterAddresses() {
    this.myHarrellsService.addressesListFiltered = this.myHarrellsService.addressesListMaster.filter(x => x.ShipToAddress.toLowerCase().indexOf(this.myHarrellsService.addressSelected.toLowerCase()) > -1);
  }

  AddressSelected(address?: any) {
    if (address == undefined) {
      this.myHarrellsService.addressSelected = "";
      this.myHarrellsService.customerAddressCodeSelected = "";
      this.myHarrellsService.thisAddressDetails = [];
      sessionStorage.setItem('PartnerSalesPersonId', '');
      sessionStorage.setItem('PartnershipCustomerAddressCodeselected', '');
      sessionStorage.setItem('PartnershipCustomerAddressSelected', '');
    }
    else {
      this.myHarrellsService.addressSelected = address.Address1;
      this.myHarrellsService.customerAddressCodeSelected = address.AddressId;
      this.myHarrellsService.GetSelectedAddressDetails()
    }

    this.showAddressList = false;

    if (this.headerBarTitle == 'Invoices') {

      this.GetCustomersInvoices().then(result => {
        this.GetInvoiceNumberMasterList();
        this.GetInvoicePOMasterList();
        this.GetItemNumberMasterList();
        this.GetClassMasterList();
        this.GetTypeMasterList();
        this.GetVendorMasterList();
        //this.GetInvoicesDateRange();
      })
    }
    else if (this.headerBarTitle == 'Open Orders') {

      this.GetCustomersOrders().then(result => {
        this.GetOrdersOrderDD();
        this.GetOrdersItemNmbrDD();
        this.GetOrdersClassDD();
        this.GetOrdersTypeDD();
        this.GetOrdersVendorDD();
      })


    }
    else if (this.headerBarTitle == 'My Products') {
      this.LoadMyProducts();
    }

  }

  AddressesFocus() {
    this.showAddressList = true;
    // this.myHarrellsService.addressSelected = ""
  }

  Logout() {
    this.myHarrellsService.loggedInMyHarrellsUser = undefined

    this.myHarrellsService.onlineOrderingInEffect = false;
    this.myHarrellsService.customerNmbrSelected = "";
    this.myHarrellsService.customerAddressCodeSelected = "";

    this.myHarrellsService.customerSelected = "";
    this.myHarrellsService.addressSelected = "";


    sessionStorage.removeItem('loggedInMyHarrellsUser');
    sessionStorage.removeItem('onlineOrderingInEffect');
    sessionStorage.removeItem('CustomerNumberSelected');
    sessionStorage.removeItem('CustomerNameSelected');
    sessionStorage.removeItem('CustomerPORequired');
    sessionStorage.removeItem('PartnershipName');
    sessionStorage.removeItem('PartnershipId');
    sessionStorage.removeItem('PartnerSalesPersonId');
    sessionStorage.removeItem('PartnershipCustomerAddressCodeselected');
    sessionStorage.removeItem('PartnershipCustomerAddressSelected');
    sessionStorage.removeItem('ShoppingCart');
    sessionStorage.removeItem('EOPMode');
    sessionStorage.removeItem('QtyByItem');
    sessionStorage.removeItem('QtyByItemMax');
    sessionStorage.removeItem('zzItemNmbr');


    this.router.navigate(['/myharrellslogin']);
  }


  MenuChanged(menu: string) {
    this.CloseAllInvoicesDropdowns();
    this.CloseAllOrdersDropdowns();
    this.CloseAllMyProductsDropdowns();


    this.headerBarTitle = menu;
    if (menu == 'Invoices') {

      this.myHarrellsService.invoicesFromDate = undefined;
      this.myHarrellsService.invoicesToDate = undefined;

      this.GetCustomersInvoices().then(result => {
        this.GetInvoiceNumberMasterList();
        this.GetInvoicePOMasterList();
        this.GetItemNumberMasterList();
        this.GetClassMasterList();
        this.GetTypeMasterList();
        this.GetVendorMasterList();
        this.GetInvoicesDateRange();
      })
    }
    else if (menu == 'Open Orders') {

      this.myHarrellsService.openOrdersBillHoldSelected = false; //default

      this.myHarrellsService.openOrdersModeSelected = "Detail"; //default

      this.GetCustomersOrders().then(result => {
        this.GetOrdersOrderDD();
        this.GetOrdersItemNmbrDD();
        this.GetOrdersClassDD();
        this.GetOrdersTypeDD();
        this.GetOrdersVendorDD();
      })
    }
    else if (menu == 'My Products') {

      this.LoadMyProducts();
    }
    else if (menu == 'Online Orders') {
      this.dotComService.cartCount = 0;
      sessionStorage.setItem('EOPMode', 'false');

      if (this.myHarrellsService.customerSelected != "" && this.myHarrellsService.addressSelected != "" && this.myHarrellsService.addressSelected != "All Addresses") {
        //got to products page
        this.myHarrellsService.onlineOrderingInEffect = true;
        sessionStorage.setItem('onlineOrderingInEffect', 'true');

        this.router.navigate(['/products']);
      }
      else {
        this.displayFailureAlert = true;
        this.failureText = "You must select a customer and specific address to continue.";
      }

    }
    else if (menu == 'Bill & Hold Items') {
      this.dotComService.cartCount = 0;
      sessionStorage.setItem('EOPMode', 'true');

      if (this.myHarrellsService.customerSelected != "" && this.myHarrellsService.addressSelected != "" && this.myHarrellsService.addressSelected != "All Addresses") {
        //check to see if this customer has any bill & hold items left to order 
        this.dotComService.partnership = this.myHarrellsService.customerNmbrSelected;
        this.dotComService.GetEOPProductSearchResults().subscribe((data) => {
          if (data && data.length > 0) {
            //go to products page
            this.myHarrellsService.onlineOrderingInEffect = true;
            sessionStorage.setItem('onlineOrderingInEffect', 'true');

            this.router.navigate(['/products']);
          }
          else {
            this.dotComService.displayWarning = true;
            this.dotComService.warningText = "There are no Bill & Hold Items available for this customer to order online at this time.";

          }

        })

      }
      else {
        this.displayFailureAlert = true;
        this.failureText = "You must select a customer and specific address to continue.";
      }
    }
  }

  LoadMyProducts() {
    this.myProductsMaster = [];
    this.myProductsFiltered = [];
    this.GetCustomersInvoices().then(Invoices => {
      this.GetCustomersOrders().then(OpenOrders => {
        //get a distinct list of items from the invoices and orders
        for (let i = 0; i < this.invoicesFiltered.length; i++) {
          if (this.myProductsMaster.findIndex(x => x.ItemNumber == this.invoicesFiltered[i].ItemNumber) == -1) {
            if (this.invoicesFiltered[i].ItemNumber != null && this.invoicesFiltered[i].ItemNumber.substring(0, 2).toUpperCase() != 'ZZ') {
              this.invoicesFiltered[i].ProductDesc = this.invoicesFiltered[i].ProductDesc.trim();
              this.invoicesFiltered[i].UofM = this.invoicesFiltered[i].UofM.trim();
              this.myProductsMaster.push(this.invoicesFiltered[i]);
            }
          }
        }

        if (this.openOrdersFiltered.length == 0) {
          this.myProductsMaster = this.myProductsMaster.sort((a, b) => (a.ItemNumber > b.ItemNumber) ? 1 : -1)
          this.myProductsFiltered = this.myProductsMaster;
        }

        for (let i = 0; i < this.openOrdersFiltered.length; i++) {
          if (this.myProductsMaster.findIndex(x => x.ItemNumber == this.openOrdersFiltered[i].ItemNumber) == -1) {
            if (this.openOrdersFiltered[i].ItemNumber != null && this.openOrdersFiltered[i].ItemNumber.substring(0, 2).toUpperCase() != 'ZZ') {
              this.openOrdersFiltered[i].ProductDesc = this.openOrdersFiltered[i].ProductDesc.trim();
              this.openOrdersFiltered[i].UofM = this.openOrdersFiltered[i].UofM.trim();
              this.myProductsMaster.push(this.openOrdersFiltered[i]);
            }
          }
          if (i == this.openOrdersFiltered.length - 1) {
            this.myProductsMaster = this.myProductsMaster.sort((a, b) => (a.ItemNumber > b.ItemNumber) ? 1 : -1)
            this.myProductsFiltered = this.myProductsMaster;
          }
        }

        //fill the dropdowns from the list
        this.myProductsVendorListFiltered = [];
        this.myProductsClassListFiltered = [];
        this.myProductsTypeListFiltered = [];
        this.myProductsVendorListMaster = [];
        this.myProductsClassListMaster = [];
        this.myProductsTypeListMaster = [];


        //get the distinct list of vendors, classes, and types
        for (let i = 0; i < this.myProductsFiltered.length; i++) {
          if (this.myProductsVendorListFiltered.indexOf(this.myProductsFiltered[i].Vendor) == -1) {
            this.myProductsVendorListFiltered.push(this.myProductsFiltered[i].Vendor);
          }
          if (this.myProductsClassListFiltered.indexOf(this.myProductsFiltered[i].Class) == -1) {
            this.myProductsClassListFiltered.push(this.myProductsFiltered[i].Class);
          }
          if (this.myProductsTypeListFiltered.indexOf(this.myProductsFiltered[i].Type) == -1) {
            this.myProductsTypeListFiltered.push(this.myProductsFiltered[i].Type);
          }
          if (i == this.myProductsFiltered.length - 1) {
            this.myProductsVendorListMaster = this.myProductsVendorListFiltered;
            this.myProductsClassListMaster = this.myProductsClassListFiltered;
            this.myProductsTypeListMaster = this.myProductsTypeListFiltered;

            this.myProductsVendorListMaster.sort();
            this.myProductsClassListMaster.sort();
            this.myProductsTypeListMaster.sort();
            this.myProductsVendorListFiltered.sort();
            this.myProductsClassListFiltered.sort();
            this.myProductsTypeListFiltered.sort();
          }
        }

      })
    })
  }

  // #region Invoice Code
  GetCustomersInvoices() {
    return new Promise((resolve, reject) => {
      this.invoicesMaster = [];
      this.invoicesFiltered = [];
      if (this.myHarrellsService.customerSelected != "") {
        this.myHarrellsService.GetCustomersInvoices().subscribe((data) => {

          //filter the result by addresses this user is allowed to see this.myHarrellsService.addressesListMaster
          if (this.myHarrellsService.loggedInMyHarrellsUser.RoleName.indexOf('HarrellsAdmin') > -1) {
            //is harrells admin so show all invoices
          }
          else {

            //check to see if the user has rights to all addresses - if so no need to filter results
            let thisCustomersAddressesList = this.myHarrellsService.addressesListMaster.filter(z => z.CustomerNumber == this.myHarrellsService.customerNmbrSelected);
            if (thisCustomersAddressesList.length > 0 && thisCustomersAddressesList.filter(x => x.AddressId == 'All Locations' && x.CustomerNumber == this.myHarrellsService.customerNmbrSelected).length > 0) {
              //they have "All Locations" access as defined for this this user in the admin panel
              //dont filter the results
            }
            else {
              if (this.myHarrellsService.addressesListMaster.length > 0) {
                data = data.filter(x => this.myHarrellsService.addressesListMaster.findIndex(y => y.AddressId == x.Adrscode) > -1);
              }
            }
          }

          if (data.length == 0) {
            resolve('');
          }
          for (let i = 0; i < data.length; i++) {
            let z = new Date(data[i].DocumentDate);
            data[i].DocumentDate = z.toLocaleDateString("en-US");
            data[i].DocumentDateYYYYMMDD = z.getFullYear() + ("0" + (z.getMonth() + 1)).slice(-2) + ("0" + z.getDate()).slice(-2)

            if (i == data.length - 1) {
              this.invoicesMaster = data
              this.invoicesFiltered = this.invoicesMaster;
              resolve('');
            }
          }
        })
      }
      else
        resolve('');
    })
  }

  GetInvoiceNumberMasterList() {
    return new Promise((resolve, reject) => {
      this.invoiceNumberMaster = [];
      this.invoiceNumberFiltered = [];
      if (this.invoicesMaster.length == 0) {
        resolve('');
      }
      for (let i = 0; i < this.invoicesMaster.length; i++) {
        if (this.invoiceNumberMaster.indexOf(this.invoicesMaster[i].SOPNumber) == -1) {
          this.invoiceNumberMaster.push(this.invoicesMaster[i].SOPNumber);
        }
        if (i == this.invoicesMaster.length - 1) {
          this.invoiceNumberFiltered = this.invoiceNumberMaster;
          this.invoiceNumberFiltered.sort();
          resolve('');
        }
      }
    })
  }


  GetInvoicePOMasterList() {
    return new Promise((resolve, reject) => {
      this.invoicePOMaster = [];
      this.invoicePOFiltered = [];
      if (this.invoicesMaster.length == 0) {
        resolve('');
      }
      for (let i = 0; i < this.invoicesMaster.length; i++) {
        if (this.invoicePOMaster.indexOf(this.invoicesMaster[i].PO) == -1) {
          this.invoicePOMaster.push(this.invoicesMaster[i].PO);
        }
        if (i == this.invoicesMaster.length - 1) {
          this.invoicePOFiltered = this.invoicePOMaster;
          this.invoicePOFiltered.sort();
          resolve('');
        }
      }
    })
  }

  GetItemNumberMasterList() {
    return new Promise((resolve, reject) => {
      this.invoicesItemNumberMaster = [];
      this.invoicesItemNumberFiltered = [];
      if (this.invoicesMaster.length == 0) {
        resolve('');
      }
      for (let i = 0; i < this.invoicesMaster.length; i++) {
        if (this.invoicesItemNumberMaster.indexOf(this.invoicesMaster[i].ItemNumber) == -1) {
          this.invoicesItemNumberMaster.push(this.invoicesMaster[i].ItemNumber);
        }
        if (i == this.invoicesMaster.length - 1) {
          this.invoicesItemNumberFiltered = this.invoicesItemNumberMaster;
          this.invoicesItemNumberFiltered.sort();
          resolve('');
        }
      }
    })
  }

  GetClassMasterList() {
    return new Promise((resolve, reject) => {
      this.invoicesClassListMaster = [];
      this.invoicesClassListFiltered = [];
      if (this.invoicesMaster.length == 0) {
        resolve('');
      }
      for (let i = 0; i < this.invoicesMaster.length; i++) {
        if (this.invoicesClassListMaster.indexOf(this.invoicesMaster[i].Class) == -1) {
          this.invoicesClassListMaster.push(this.invoicesMaster[i].Class);
        }
        if (i == this.invoicesMaster.length - 1) {
          this.invoicesClassListFiltered = this.invoicesClassListMaster;
          this.invoicesClassListFiltered.sort();
          resolve('');
        }
      }
    })
  }

  GetTypeMasterList() {
    return new Promise((resolve, reject) => {
      this.invoicesTypeListMaster = [];
      this.invoicesTypeListFiltered = [];
      if (this.invoicesMaster.length == 0) {
        resolve('');
      }
      for (let i = 0; i < this.invoicesMaster.length; i++) {
        if (this.invoicesTypeListMaster.indexOf(this.invoicesMaster[i].Type) == -1) {
          this.invoicesTypeListMaster.push(this.invoicesMaster[i].Type);
        }
        if (i == this.invoicesMaster.length - 1) {
          this.invoicesTypeListFiltered = this.invoicesTypeListMaster;
          this.invoicesTypeListFiltered.sort();
          resolve('');
        }
      }
    })
  }

  GetVendorMasterList() {
    return new Promise((resolve, reject) => {
      this.invoicesVendorListMaster = [];
      this.invoicesVendorListFiltered = [];
      if (this.invoicesMaster.length == 0) {
        resolve('');
      }
      for (let i = 0; i < this.invoicesMaster.length; i++) {
        if (this.invoicesVendorListMaster.indexOf(this.invoicesMaster[i].Vendor.trim()) == -1) {
          this.invoicesVendorListMaster.push(this.invoicesMaster[i].Vendor.trim());
        }
        if (i == this.invoicesMaster.length - 1) {
          this.invoicesVendorListFiltered = this.invoicesVendorListMaster;
          this.invoicesVendorListFiltered.sort();
          resolve('');
        }
      }
    })
  }


  SortInvoicesGrid(sortBy: string) {
    if (this.sortDir == "asc" || this.sortDir == "") {
      //sorting ascending
      if (sortBy == 'Invoice#') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.SOPNumber > b.SOPNumber) ? 1 : -1)
      }
      if (sortBy == 'PO#') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.PO > b.PO) ? 1 : -1)
      }
      else if (sortBy == 'Date') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.DocumentDateYYYYMMDD > b.DocumentDateYYYYMMDD) ? 1 : -1)
      }
      else if (sortBy == 'Type') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.Type > b.Type) ? 1 : -1)
      }
      else if (sortBy == 'Vendor') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.Vendor > b.Vendor) ? 1 : -1)
      }
      else if (sortBy == 'Class') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.Class > b.Class) ? 1 : -1)
      }
      else if (sortBy == 'Item') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.ItemNumber > b.ItemNumber) ? 1 : -1)
      }
      else if (sortBy == 'Qty') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.Quantity > b.Quantity) ? 1 : -1)
      }
      else if (sortBy == 'Price') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.UnitPrice > b.UnitPrice) ? 1 : -1)
      }
      else if (sortBy == 'Total') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.ExtendedPrice > b.ExtendedPrice) ? 1 : -1)
      }
      else if (sortBy == 'NumItems') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.NumItems > b.NumItems) ? 1 : -1)
      }
      else if (sortBy == 'ShipTo') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.Address1 > b.Address1) ? 1 : -1)
      }

      this.sortDir = 'desc';
    }
    else {
      //sorting descending
      if (sortBy == 'Invoice#') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.SOPNumber > b.SOPNumber) ? -1 : 1)
      }
      if (sortBy == 'PO#') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.PO > b.PO) ? -1 : 1)
      }
      else if (sortBy == 'Date') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.DocumentDateYYYYMMDD > b.DocumentDateYYYYMMDD) ? -1 : 1)
      }
      else if (sortBy == 'Type') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.Type > b.Type) ? -1 : 1)
      }
      else if (sortBy == 'Vendor') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.Vendor > b.Vendor) ? -1 : 1)
      }
      else if (sortBy == 'Class') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.Class > b.Class) ? -1 : 1)
      }
      else if (sortBy == 'Item') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.ItemNumber > b.ItemNumber) ? -1 : 1)
      }
      else if (sortBy == 'Qty') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.Quantity > b.Quantity) ? -1 : 1)
      }
      else if (sortBy == 'Price') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.UnitPrice > b.UnitPrice) ? -1 : 1)
      }
      else if (sortBy == 'Total') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.ExtendedPrice > b.ExtendedPrice) ? -1 : 1)
      }
      else if (sortBy == 'NumItems') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.NumItems > b.NumItems) ? -1 : 1)
      }
      else if (sortBy == 'ShipTo') {
        this.invoicesFiltered = this.invoicesFiltered.sort((a, b) => (a.Address1 > b.Address1) ? -1 : 1)
      }

      this.sortDir = 'asc';
    }
  }

  InvoicePOFocus() {
    this.CloseAllInvoicesDropdowns();
    this.showInvoicePOList = true;
  }

  FilterInvoicePO() {
    this.invoicePOFiltered = this.invoicePOMaster.filter(x => x.toLowerCase().indexOf(this.myHarrellsService.invoicesPOSelected.toLowerCase()) > -1);
  }

  InvoicePOSelected(po: any) {
    this.myHarrellsService.invoicesPOSelected = po;
    this.myHarrellsService.invoicesFromDate = undefined;
    this.myHarrellsService.invoicesToDate = undefined;
    this.showInvoicePOList = false;


    this.GetCustomersInvoices().then(result => {
      this.GetInvoiceNumberMasterList();
      this.GetInvoicePOMasterList();
      this.GetItemNumberMasterList();
      this.GetClassMasterList();
      this.GetTypeMasterList();
      this.GetVendorMasterList();
      // this.GetInvoicesDateRange();

    })
  }


  InvoiceNumberFocus() {
    this.CloseAllInvoicesDropdowns();
    this.showInvoiceNumberList = true;
  }

  FilterInvoiceNumbers() {
    this.invoiceNumberFiltered = this.invoiceNumberMaster.filter(x => x.toLowerCase().indexOf(this.myHarrellsService.invoicesInvoiceNumberSelected.toLowerCase()) > -1);
  }

  InvoiceNumberSelected(invoice: any) {
    this.myHarrellsService.invoicesInvoiceNumberSelected = invoice;
    this.myHarrellsService.invoicesFromDate = undefined;
    this.myHarrellsService.invoicesToDate = undefined;
    this.showInvoiceNumberList = false;

    // this.invoicesFiltered = this.invoicesMaster.filter(x => x.SOPNumber.toLowerCase().indexOf(this.myHarrellsService.invoiceNumberSelected.toLowerCase()) > -1);
    // this.FilterInvoices();

    this.GetCustomersInvoices().then(result => {
      this.GetInvoiceNumberMasterList();
      this.GetInvoicePOMasterList();
      this.GetItemNumberMasterList();
      this.GetClassMasterList();
      this.GetTypeMasterList();
      this.GetVendorMasterList();
      // this.GetInvoicesDateRange();

    })
  }

  InvoiceFromDateFocus() {
    this.CloseAllInvoicesDropdowns();
  }

  InvoiceToDateFocus() {
    this.CloseAllInvoicesDropdowns();
  }


  ItemNumberFocus() {
    this.CloseAllInvoicesDropdowns();
    this.showInvoicesItemNumbersList = true;
  }

  FilterItemNumbers() {
    this.invoicesItemNumberFiltered = this.invoicesItemNumberMaster.filter(x => x.toLowerCase().indexOf(this.myHarrellsService.invoicesItemNumberSelected.toLowerCase()) > -1);
  }

  ItemNumberSelected(invoice: any) {
    this.myHarrellsService.invoicesItemNumberSelected = invoice;
    this.myHarrellsService.invoicesFromDate = undefined;
    this.myHarrellsService.invoicesToDate = undefined;
    this.showInvoicesItemNumbersList = false;

    // this.invoicesFiltered = this.invoicesMaster.filter(x => x.ItemNumber.toLowerCase().indexOf(this.myHarrellsService.itemNumberSelected.toLowerCase()) > -1);
    // this.FilterInvoices();

    this.GetCustomersInvoices().then(result => {
      this.GetInvoiceNumberMasterList();
      this.GetInvoicePOMasterList();
      this.GetItemNumberMasterList();
      this.GetClassMasterList();
      this.GetTypeMasterList();
      this.GetVendorMasterList();
      // this.GetInvoicesDateRange();
    })
  }

  ClassFocus() {
    this.CloseAllInvoicesDropdowns();
    this.showInvoicesClassList = true;
  }

  FilterClasses() {
    this.invoicesClassListFiltered = this.invoicesClassListMaster.filter(x => x.toLowerCase().indexOf(this.myHarrellsService.invoicesClassSelected.toLowerCase()) > -1);
  }

  ClassSelected(selectedClass: any) {
    this.myHarrellsService.invoicesClassSelected = selectedClass;
    this.myHarrellsService.invoicesFromDate = undefined;
    this.myHarrellsService.invoicesToDate = undefined;
    this.showInvoicesClassList = false;

    this.GetCustomersInvoices().then(result => {
      this.GetInvoiceNumberMasterList();
      this.GetInvoicePOMasterList();
      this.GetItemNumberMasterList();
      this.GetClassMasterList();
      this.GetTypeMasterList();
      this.GetVendorMasterList();
      // this.GetInvoicesDateRange();
    })

  }

  TypeFocus() {
    this.CloseAllInvoicesDropdowns();
    this.showInvoicesTypeList = true;
  }

  FilterType() {
    this.invoicesTypeListFiltered = this.invoicesTypeListMaster.filter(x => x.toLowerCase().indexOf(this.myHarrellsService.invoicesTypeSelected.toLowerCase()) > -1);
  }

  TypeSelected(type: any) {
    this.myHarrellsService.invoicesTypeSelected = type;
    this.myHarrellsService.invoicesFromDate = undefined;
    this.myHarrellsService.invoicesToDate = undefined;
    this.showInvoicesTypeList = false;

    //reload the other dropdowns since the list of invoices has changed
    this.GetCustomersInvoices().then(result => {
      this.GetInvoiceNumberMasterList();
      this.GetInvoicePOMasterList();
      this.GetItemNumberMasterList();
      this.GetClassMasterList();
      this.GetTypeMasterList();
      this.GetVendorMasterList();
      // this.GetInvoicesDateRange();
    })
  }

  VendorFocus() {
    this.CloseAllInvoicesDropdowns();

    this.showInvoicesVendorList = true;
  }

  FilterVendor() {
    this.invoicesVendorListFiltered = this.invoicesVendorListMaster.filter(x => x.toLowerCase().indexOf(this.myHarrellsService.invoicesVendorSelected.toLowerCase()) > -1);
  }

  VendorSelected(vendor: any) {
    this.myHarrellsService.invoicesVendorSelected = vendor;
    this.myHarrellsService.invoicesFromDate = undefined;
    this.myHarrellsService.invoicesToDate = undefined;
    this.showInvoicesVendorList = false;

    //reload dropdowns and grid
    this.GetCustomersInvoices().then(result => {
      this.GetInvoiceNumberMasterList();
      this.GetInvoicePOMasterList();
      this.GetItemNumberMasterList();
      this.GetClassMasterList();
      this.GetTypeMasterList();
      this.GetVendorMasterList();
      // this.GetInvoicesDateRange();
    })
  }

  InvoiceFromDateChanged(e: any) {
    this.myHarrellsService.invoicesFromDate = e.target.value;
    //reload dropdowns and grid
    this.GetCustomersInvoices().then(result => {
      this.GetInvoiceNumberMasterList();
      this.GetInvoicePOMasterList();
      this.GetItemNumberMasterList();
      this.GetClassMasterList();
      this.GetTypeMasterList();
      this.GetVendorMasterList();
    })
  }

  InvoiceToDateChanged(e: any) {
    this.myHarrellsService.invoicesToDate = e.target.value;
    //reload dropdowns and grid
    this.GetCustomersInvoices().then(result => {
      this.GetInvoiceNumberMasterList();
      this.GetInvoicePOMasterList();
      this.GetItemNumberMasterList();
      this.GetClassMasterList();
      this.GetTypeMasterList();
      this.GetVendorMasterList();
    })
  }

  ViewInvoiceRadioChanged(e: any) {
    //radio changed and this is the one that is selected

    this.myHarrellsService.invoicesFromDate = undefined;
    this.myHarrellsService.invoicesToDate = undefined;

    if (e.target.id == 'detailView' || e.target.id == 'detailViewMobile') {
      this.myHarrellsService.invoiceModeSelected = 'Detail';
    }
    else {
      this.myHarrellsService.invoiceModeSelected = 'Summary';
      this.myHarrellsService.invoicesItemNumberSelected = "";
      this.myHarrellsService.invoicesClassSelected = "";
      this.myHarrellsService.invoicesTypeSelected = "";
      this.myHarrellsService.invoicesVendorSelected = "";

    }
    //reload dropdowns and grid
    this.GetCustomersInvoices().then(result => {
      this.GetInvoiceNumberMasterList();
      this.GetInvoicePOMasterList();
      this.GetItemNumberMasterList();
      this.GetClassMasterList();
      this.GetTypeMasterList();
      this.GetVendorMasterList();
      // this.GetInvoicesDateRange();
    })
  }

  DollaryInvoiceRadioChanged(e: any) {

    this.myHarrellsService.invoicesFromDate = undefined;
    this.myHarrellsService.invoicesToDate = undefined;

    //radio changed and this is the one that is selected
    if (e.target.id == 'nonZero') {
      this.myHarrellsService.invoiceShowNonZeroOnlySelected = false;
    }
    else {
      this.myHarrellsService.invoiceShowNonZeroOnlySelected = true;
    }
    //reload dropdowns and grid
    this.GetCustomersInvoices().then(result => {
      this.GetInvoiceNumberMasterList();
      this.GetInvoicePOMasterList();
      this.GetItemNumberMasterList();
      this.GetClassMasterList();
      this.GetTypeMasterList();
      this.GetVendorMasterList();
      // this.GetInvoicesDateRange();
    })
  }

  GetInvoiceExcel() {

    //using the array that populates the grid for the excel file contents
    let xlarray = [];

    if (this.myHarrellsService.invoiceModeSelected == "Detail") {
      //detail report 

      for (let i = 0; i < this.invoicesFiltered.length; i++) {
        xlarray.push({
          "Invoice#": this.invoicesFiltered[i].SOPNumber,
          "PO#": this.invoicesFiltered[i].PO,
          "Date": this.invoicesFiltered[i].DocumentDate,
          "Item": this.invoicesFiltered[i].ItemNumber,
          "Class": this.invoicesFiltered[i].Class,
          "Type": this.invoicesFiltered[i].Type,
          "Vendor": this.invoicesFiltered[i].Vendor,
          "Qty": this.invoicesFiltered[i].Quantity,
          "Price": this.invoicesFiltered[i].UnitPrice,
          "Total": this.invoicesFiltered[i].ExtendedPrice,
        })
      }


      let wb = XLSX.utils.book_new();
      var ws = XLSX.utils.json_to_sheet(xlarray);

      //add filters to spreasheets in columns K and L
      XLSX.utils.sheet_add_aoa(ws, [['--FILTERS--']], { origin: 'L1' });
      XLSX.utils.sheet_add_aoa(ws, [['Invoice #:']], { origin: 'L2' });
      XLSX.utils.sheet_add_aoa(ws, [['Item:']], { origin: 'L3' });
      XLSX.utils.sheet_add_aoa(ws, [['Class:']], { origin: 'L4' });
      XLSX.utils.sheet_add_aoa(ws, [['Type:']], { origin: 'L5' });
      XLSX.utils.sheet_add_aoa(ws, [['Vendor:']], { origin: 'L6' });
      XLSX.utils.sheet_add_aoa(ws, [['Start:']], { origin: 'L7' });
      XLSX.utils.sheet_add_aoa(ws, [['End:']], { origin: 'L8' });

      XLSX.utils.sheet_add_aoa(ws, [['Report Type:']], { origin: 'L9' });
      XLSX.utils.sheet_add_aoa(ws, [['Invoice Type:']], { origin: 'L10' });


      XLSX.utils.sheet_add_aoa(ws, [['']], { origin: 'M1' });
      XLSX.utils.sheet_add_aoa(ws, [[this.myHarrellsService.invoicesInvoiceNumberSelected]], { origin: 'M2' });
      XLSX.utils.sheet_add_aoa(ws, [[this.myHarrellsService.invoicesItemNumberSelected]], { origin: 'M3' });
      XLSX.utils.sheet_add_aoa(ws, [[this.myHarrellsService.invoicesClassSelected]], { origin: 'M4' });
      XLSX.utils.sheet_add_aoa(ws, [[this.myHarrellsService.invoicesTypeSelected]], { origin: 'M5' });
      XLSX.utils.sheet_add_aoa(ws, [[this.myHarrellsService.invoicesVendorSelected]], { origin: 'M6' });
      XLSX.utils.sheet_add_aoa(ws, [[(document.getElementById('invoicesFromDate') as HTMLInputElement).value]], { origin: 'M7' });
      XLSX.utils.sheet_add_aoa(ws, [[(document.getElementById('invoicesToDate') as HTMLInputElement).value]], { origin: 'M8' });


      XLSX.utils.sheet_add_aoa(ws, [[this.myHarrellsService.invoiceModeSelected]], { origin: 'M9' });
      XLSX.utils.sheet_add_aoa(ws, [[(!this.myHarrellsService.invoiceShowNonZeroOnlySelected) ? "Non-Zero" : "All"]], { origin: 'M10' });


      ws['!cols'] = [
        { wch: 15 }, // Width of column 1
        { wch: 15 }, // Width of column 2
        { wch: 15 }, // Width of column 3
        { wch: 15 }, // Width of column 4
        { wch: 15 }, // Width of column 5
        { wch: 15 }, // Width of column 6
        { wch: 15 }, // Width of column 7
        { wch: 15 }, // Width of column 8
        { wch: 15 }, // Width of column 9
        { wch: 15 }, // Width of column 10
        { wch: 15 }, // Width of column 11
        { wch: 15 }, // Width of column 12
        { wch: 15 }, // Width of column 13
      ];


      //send the file to the browser
      XLSX.utils.book_append_sheet(wb, ws, this.myHarrellsService.customerSelected);
      XLSX.writeFile(wb, this.myHarrellsService.customerSelected + ' invoices.xlsx');

      this.displaySuccessAlert = true;
      this.successText = "Your report is being generated.  Please check your downloads folder for the file '" + this.myHarrellsService.customerSelected + " invoices.xlsx'";
    }
    else {
      //summary view report
      for (let i = 0; i < this.invoicesFiltered.length; i++) {
        xlarray.push({
          "Invoice#": this.invoicesFiltered[i].SOPNumber,
          "PO#": this.invoicesFiltered[i].PO,
          "Date": this.invoicesFiltered[i].DocumentDate,
          "Ship To": this.invoicesFiltered[i].Address1.trim() + " " + this.invoicesFiltered[i].City.trim() + " " + this.invoicesFiltered[i].State,
          "# Items": this.invoicesFiltered[i].NumItems,
          "Total": this.invoicesFiltered[i].ExtendedPrice,
        })
      }

      let wb = XLSX.utils.book_new();
      var ws = XLSX.utils.json_to_sheet(xlarray);

      //add filters to spreasheets in columns K and L
      XLSX.utils.sheet_add_aoa(ws, [['--FILTERS--']], { origin: 'H1' });
      XLSX.utils.sheet_add_aoa(ws, [['Invoice #:']], { origin: 'H2' });
      XLSX.utils.sheet_add_aoa(ws, [['Start:']], { origin: 'H3' });
      XLSX.utils.sheet_add_aoa(ws, [['End:']], { origin: 'H4' });
      XLSX.utils.sheet_add_aoa(ws, [['Report Type:']], { origin: 'H5' });
      XLSX.utils.sheet_add_aoa(ws, [['Invoice Type:']], { origin: 'H6' });


      XLSX.utils.sheet_add_aoa(ws, [['']], { origin: 'I1' });
      XLSX.utils.sheet_add_aoa(ws, [[this.myHarrellsService.invoicesInvoiceNumberSelected]], { origin: 'I2' });
      XLSX.utils.sheet_add_aoa(ws, [[(document.getElementById('invoicesFromDate') as HTMLInputElement).value]], { origin: 'I3' });
      XLSX.utils.sheet_add_aoa(ws, [[(document.getElementById('invoicesToDate') as HTMLInputElement).value]], { origin: 'I4' });
      XLSX.utils.sheet_add_aoa(ws, [[this.myHarrellsService.invoiceModeSelected]], { origin: 'I5' });
      XLSX.utils.sheet_add_aoa(ws, [[(!this.myHarrellsService.invoiceShowNonZeroOnlySelected) ? "Non-Zero" : "All"]], { origin: 'I6' });

      ws['!cols'] = [
        { wch: 15 }, // Width of column 1
        { wch: 15 }, // Width of column 2
        { wch: 30 }, // Width of column 3
        { wch: 15 }, // Width of column 4
        { wch: 15 }, // Width of column 5
        { wch: 15 }, // Width of column 6
        { wch: 15 }, // Width of column 7
        { wch: 15 }, // Width of column 8
        { wch: 15 }, // Width of column 9
      ];

      //send the file to the browser
      XLSX.utils.book_append_sheet(wb, ws, this.myHarrellsService.customerSelected);
      XLSX.writeFile(wb, this.myHarrellsService.customerSelected + ' invoices.xlsx');

      this.displaySuccessAlert = true;
      this.successText = "Your report is being generated.  Please check your downloads folder for the file '" + this.myHarrellsService.customerSelected + " invoices.xlsx'";
    }
  }

  OpenPdfDoc(docType: string, id2: string) {
    this.myHarrellsService.GetPDFDocument(docType, id2).subscribe((response: any) => {
      if (response.length == 0) {
        this.displayFailureAlert = true;
        if (this.rep) {
          this.failureText = "There was an error retrieving the PDF document.  " +
            "Please try again later or contact your rep (" + this.rep.SalesRep +
            " - <a href='mailto:" + this.rep.SalesRepEmail + "?subject=Invoice Needed'>" + this.rep.SalesRepEmail + "</a> - <a href='tel:" + this.rep.SalesRepPhone + "'>" + this.rep.SalesRepPhone + "</a>) and they can obtain a copy from Accounting for you.";
        }
        else {
          //must be an admin logged in so we can not pick up their rep info
          this.failureText = "There was an error retrieving the PDF document. Please try again later.";
        }
      }
      else {
        //let PDFWindow = window.open(response[0].DocName, '_blank'); //does not work on safari 
        var windowReference = window.open();
        windowReference.location = response[0].DocName;
      }
    })
  }

  ShowLineItemsOnSummary(invNum: string) {
    if (this.myHarrellsService.invoiceModeSelected == 'Summary') {

      if (this.myHarrellsService.invoicesInvoiceNumberSelected == invNum) {
        //hide the one that is showing 
        this.myHarrellsService.invoicesInvoiceNumberSelected = ""
      }
      else {
        //expand and show the items for the invoice 
        this.myHarrellsService.invoicesInvoiceNumberSelected = invNum;
        //get the line item detail for this invoice and display in the grid row that expanded
        this.invoicesItems = [];
        this.myHarrellsService.GetInvoiceLineItems(invNum).subscribe((data) => {
          this.invoicesItems = data;
        })
      }
    }
  }

  HideSuccessAlert() {
    this.displaySuccessAlert = false;
  }

  HideFailureAlert() {
    this.displayFailureAlert = false;
  }

  // #endregion

  // #region Open Orders

  GetCustomersOrders() {
    return new Promise((resolve, reject) => {
      this.openOrdersMaster = [];
      this.openOrdersFiltered = [];
      if (this.myHarrellsService.customerSelected != "") {
        this.myHarrellsService.GetCustomersOpenOrders().subscribe((data) => {

          //filter the result by addresses this user is allowed to see this.myHarrellsService.addressesListMaster
          if (this.myHarrellsService.loggedInMyHarrellsUser.RoleName.indexOf('HarrellsAdmin') > -1) {
            //is harrells admin so show all orders
          }
          else {

            //check to see if the user has rights to all addresses - if so no need to filter results
            let thisCustomersAddressesList = this.myHarrellsService.addressesListMaster.filter(z => z.CustomerNumber == this.myHarrellsService.customerNmbrSelected);
            if (thisCustomersAddressesList.length > 0 && thisCustomersAddressesList.filter(x => x.AddressId == 'All Locations' && x.CustomerNumber == this.myHarrellsService.customerNmbrSelected).length > 0) {
              //they have "All Locations" access as defined for this this user in the admin panel
              //dont filter the results
            }
            else {
              if (this.myHarrellsService.addressesListMaster.length > 0) {
                data = data.filter(x => this.myHarrellsService.addressesListMaster.findIndex(y => y.AddressId == x.Adrscode) > -1);
              }
            }
          }

          if (data.length == 0) {
            resolve('');
          }

          for (let i = 0; i < data.length; i++) {
            let z = new Date(data[i].DocumentDate);
            data[i].DocumentDate = z.toLocaleDateString("en-US");
            data[i].DocumentDateYYYYMMDD = z.getFullYear() + ("0" + (z.getMonth() + 1)).slice(-2) + ("0" + z.getDate()).slice(-2)

            let zz = new Date(data[i].RequestedShipDate);
            data[i].RequestedShipDate = zz.toLocaleDateString("en-US");
            data[i].RequestedShipDateYYYYMMDD = zz.getFullYear() + ("0" + (zz.getMonth() + 1)).slice(-2) + ("0" + zz.getDate()).slice(-2)

            data[i].Status = (data[i].DispatchStatusId < 2) ? "New Order" : (data[i].DispatchStatusId == 2) ? "Scheduled" : (data[i].DispatchStatusId == 3) ? "Loaded" : "Delivered";


            if (i == data.length - 1) {
              this.openOrdersMaster = data
              this.openOrdersFiltered = this.openOrdersMaster;
              resolve('');
            }
          }
        })
      }
      else
        resolve('');
    })
  }

  //sop dropdown
  GetOrdersOrderDD() {
    this.ordersSOPNumberMaster = [];
    this.ordersSOPNumberFiltered = [];
    if (this.openOrdersFiltered.length > 0) {
      this.myHarrellsService.GetOrdersOrderDD().subscribe((data) => {
        data = data.filter(x => x.SOPNumber != null);
        this.ordersSOPNumberMaster = data
        this.ordersSOPNumberFiltered = this.ordersSOPNumberMaster;
      })
    }
  }

  OrdersSopNumberFocus() {
    this.CloseAllOrdersDropdowns();

    this.showOrdersSOPNumberList = true;
  }

  FilterOrdersSOPNumbers() {
    this.ordersSOPNumberFiltered = this.ordersSOPNumberMaster.filter(x => x.SOPNumber.toLowerCase().indexOf(this.myHarrellsService.orderSOPNumberSelected.toLowerCase()) > -1);
  }

  OrdersSOPNumberSelected(sopNumber: any) {
    this.myHarrellsService.orderSOPNumberSelected = sopNumber;
    this.showOrdersSOPNumberList = false

    this.GetCustomersOrders().then(result => {
      this.GetOrdersOrderDD();
      this.GetOrdersItemNmbrDD();
      this.GetOrdersClassDD();
      this.GetOrdersTypeDD();
      this.GetOrdersVendorDD();
    })
  }

  //item number dropdown
  GetOrdersItemNmbrDD() {
    this.ordersItemNumberFiltered = [];
    this.ordersItemNumberMaster = [];
    if (this.openOrdersFiltered.length > 0) {
      this.myHarrellsService.GetOrdersItemNmbrDD().subscribe((data) => {
        data = data.filter(x => x.ItemNumber != null);
        this.ordersItemNumberMaster = data
        this.ordersItemNumberFiltered = this.ordersItemNumberMaster;
      })
    }

  }

  OrdersItemNumberFocus() {

    //close any open dropdowns
    this.CloseAllOrdersDropdowns();

    this.showOrdersItemNumberList = true;
  }

  FilterOrdersItemNumbers() {
    this.ordersItemNumberFiltered = this.ordersItemNumberMaster.filter(x => x.ItemNumber.toLowerCase().indexOf(this.myHarrellsService.ordersItemNumberSelected.toLowerCase()) > -1);
  }

  OrdersItemNumberSelected(itemNmbr: any) {
    this.myHarrellsService.ordersItemNumberSelected = itemNmbr;
    this.showOrdersItemNumberList = false

    this.GetCustomersOrders().then(result => {
      this.GetOrdersOrderDD();
      this.GetOrdersItemNmbrDD();
      this.GetOrdersClassDD();
      this.GetOrdersTypeDD();
      this.GetOrdersVendorDD();
    })
  }

  //class dropdown
  GetOrdersClassDD() {
    this.ordersClassesMaster = [];
    this
    if (this.openOrdersFiltered.length > 0) {
      this.myHarrellsService.GetOrdersClassDD().subscribe((data) => {
        data = data.filter(x => x.Class != null);
        this.ordersClassesMaster = data
        this.ordersClassesFiltered = this.ordersClassesMaster

      })
    }
  }

  OrdersClassesFocus() {
    this.CloseAllOrdersDropdowns();

    this.showOrdersClassesList = true;
  }

  FilterOrdersClasses() {
    this.ordersClassesFiltered = this.ordersClassesMaster.filter(x => x.Class.toLowerCase().indexOf(this.myHarrellsService.ordersClassSelected.toLowerCase()) > -1);
  }

  OrdersClassSelected(theclass: any) {
    this.myHarrellsService.ordersClassSelected = theclass
    this.showOrdersClassesList = false

    this.GetCustomersOrders().then(result => {
      this.GetOrdersOrderDD();
      this.GetOrdersItemNmbrDD();
      this.GetOrdersClassDD();
      this.GetOrdersTypeDD();
      this.GetOrdersVendorDD();
    })
  }

  //type dropdown
  GetOrdersTypeDD() {
    this.ordersTypesMaster = [];
    this.ordersTypesFiltered = [];
    if (this.openOrdersFiltered.length > 0) {
      this.myHarrellsService.GetOrdersTypeDD().subscribe((data) => {
        data = data.filter(x => x.Type != null);
        this.ordersTypesMaster = data
        this.ordersTypesFiltered = this.ordersTypesMaster
      })
    }
  }

  OrdersTypesFocus() {
    this.CloseAllOrdersDropdowns();

    this.showOrdersTypesList = true;
  }

  FilterOrdersTypes() {
    this.ordersTypesFiltered = this.ordersTypesMaster.filter(x => x.Type.toLowerCase().indexOf(this.myHarrellsService.ordersTypeSelected.toLowerCase()) > -1);
  }

  OrdersTypeSelected(thisType: any) {
    this.myHarrellsService.ordersTypeSelected = thisType
    this.showOrdersTypesList = false

    this.GetCustomersOrders().then(result => {
      this.GetOrdersOrderDD();
      this.GetOrdersItemNmbrDD();
      this.GetOrdersClassDD();
      this.GetOrdersTypeDD();
      this.GetOrdersVendorDD();
    })
  }

  //vendor dropdown
  GetOrdersVendorDD() {
    this.ordersVendorsMaster = [];
    this.ordersVendorsFiltered = [];
    if (this.openOrdersFiltered.length > 0) {
      this.myHarrellsService.GetOrdersVendorDD().subscribe((data) => {
        data = data.filter(x => x.Vendor != null);
        this.ordersVendorsMaster = data
        this.ordersVendorsFiltered = this.ordersVendorsMaster
      })
    }

  }

  OrdersVendorsFocus() {
    this.CloseAllOrdersDropdowns();

    this.showOrdersVendorsList = true;
  }

  FilterOrdersVendors() {
    this.ordersVendorsFiltered = this.ordersVendorsMaster.filter(x => x.Vendor.toLowerCase().indexOf(this.myHarrellsService.ordersVendorSelected.toLowerCase()) > -1);
  }

  OrdersVendorSelected(thisVendor: any) {
    this.myHarrellsService.ordersVendorSelected = thisVendor
    this.showOrdersVendorsList = false

    this.GetCustomersOrders().then(result => {
      this.GetOrdersOrderDD();
      this.GetOrdersItemNmbrDD();
      this.GetOrdersClassDD();
      this.GetOrdersTypeDD();
      this.GetOrdersVendorDD();
    })
  }

  SortOpenOrdersGrid(sortBy: string) {
    if (this.sortDir == "asc" || this.sortDir == "") {
      //sorting ascending
      if (sortBy == 'Order#') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.SOPNumber > b.SOPNumber) ? 1 : -1)
      }
      else if (sortBy == 'Date') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.DocumentDateYYYYMMDD > b.DocumentDateYYYYMMDD) ? 1 : -1)
      }
      else if (sortBy == 'Item') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.ItemNumber > b.ItemNumber) ? 1 : -1)
      }
      else if (sortBy == 'Class') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.Class > b.Class) ? 1 : -1)
      }
      else if (sortBy == 'Type') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.Type > b.Type) ? 1 : -1)
      }
      else if (sortBy == 'Vendor') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.Vendor > b.Vendor) ? 1 : -1)
      }
      else if (sortBy == 'ReqShip') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.RequestedShipDate > b.RequestedShipDate) ? 1 : -1)
      }
      else if (sortBy == 'Qty') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.Quantity > b.Quantity) ? 1 : -1)
      }
      else if (sortBy == 'ShipTo') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.ShipToAddress > b.ShipToAddress) ? 1 : -1)
      }
      else if (sortBy == 'Status') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.Status > b.Status) ? 1 : -1)
      }
      else if (sortBy == 'CityState') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.CityState > b.CityState) ? 1 : -1)
      }
      else if (sortBy == 'Total') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.ExtendedPrice > b.ExtendedPrice) ? 1 : -1)
      }


      this.sortDir = 'desc';
    }
    else {
      //sorting descending
      if (sortBy == 'Order#') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.SOPNumber > b.SOPNumber) ? -1 : 1)
      }
      else if (sortBy == 'Date') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.DocumentDateYYYYMMDD > b.DocumentDateYYYYMMDD) ? -1 : 1)
      }
      else if (sortBy == 'Item') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.ItemNumber > b.ItemNumber) ? -1 : 1)
      }
      else if (sortBy == 'Class') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.Class > b.Class) ? -1 : 1)
      }
      else if (sortBy == 'Type') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.Type > b.Type) ? -1 : 1)
      }
      else if (sortBy == 'Vendor') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.Vendor > b.Vendor) ? -1 : 1)
      }
      else if (sortBy == 'ReqShip') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.RequestedShipDate > b.RequestedShipDate) ? -1 : 1)
      }
      else if (sortBy == 'Qty') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.Quantity > b.Quantity) ? -1 : 1)
      }
      else if (sortBy == 'ShipTo') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.ShipToAddress > b.ShipToAddress) ? -1 : 1)
      }
      else if (sortBy == 'Status') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.Status > b.Status) ? -1 : 1)
      }
      else if (sortBy == 'CityState') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.CityState > b.CityState) ? -1 : 1)
      }
      else if (sortBy == 'Total') {
        this.openOrdersFiltered = this.openOrdersFiltered.sort((a, b) => (a.ExtendedPrice > b.ExtendedPrice) ? -1 : 1)
      }

      this.sortDir = 'asc';
    }
  }

  ViewOrderRadioChanged(e: any) {
    //radio changed and this is the one that is selected


    if (e.target.id == 'detailView' || e.target.id == 'detailViewMobile') {
      this.myHarrellsService.openOrdersModeSelected = 'Detail';
    }
    else {
      this.myHarrellsService.openOrdersModeSelected = 'Summary';
      this.myHarrellsService.ordersItemNumberSelected = "";
      this.myHarrellsService.ordersClassSelected = "";
      this.myHarrellsService.ordersTypeSelected = "";
      this.myHarrellsService.ordersVendorSelected = "";

    }
    //reload dropdowns and grid
    this.GetCustomersOrders().then(result => {
      this.GetOrdersOrderDD();
      this.GetOrdersItemNmbrDD();
      this.GetOrdersClassDD();
      this.GetOrdersTypeDD();
      this.GetOrdersVendorDD();
    })
  }

  RegularBHRadioChanged(e: any) {
    //radio changed and this is the one that is selected
    if (e.target.id == 'regularOrders' || e.target.id == 'regularOrdersMobile') {
      this.myHarrellsService.openOrdersBillHoldSelected = false;
    }
    else {
      this.myHarrellsService.openOrdersBillHoldSelected = true;
    }
    //reload dropdowns and grid
    this.GetCustomersOrders().then(result => {
      this.GetOrdersOrderDD();
      this.GetOrdersItemNmbrDD();
      this.GetOrdersClassDD();
      this.GetOrdersTypeDD();
      this.GetOrdersVendorDD();
    })
  }

  GetOrdersExcel() {
    //using the array that populates the grid for the excel file contents
    let xlarray = [];


    if (this.myHarrellsService.openOrdersModeSelected == "Detail") {
      //detail report 

      for (let i = 0; i < this.openOrdersFiltered.length; i++) {
        xlarray.push({
          "Order#": this.openOrdersFiltered[i].SOPNumber,
          "Date": this.openOrdersFiltered[i].DocumentDate,
          "Item": this.openOrdersFiltered[i].ItemNumber,
          "Class": this.openOrdersFiltered[i].Class,
          "Type": this.openOrdersFiltered[i].Type,
          "Vendor": this.openOrdersFiltered[i].Vendor,
          "Req_Ship": this.openOrdersFiltered[i].RequestedShipDate,
          "Qty": this.openOrdersFiltered[i].Quantity,
          "Ship_To": this.openOrdersFiltered[i].ShipToAddress
        })
      }


      let wb = XLSX.utils.book_new();
      var ws = XLSX.utils.json_to_sheet(xlarray);

      //add filters to spreasheets in columns K and L
      XLSX.utils.sheet_add_aoa(ws, [['--FILTERS--']], { origin: 'L1' });
      XLSX.utils.sheet_add_aoa(ws, [['Order #:']], { origin: 'L2' });
      XLSX.utils.sheet_add_aoa(ws, [['Item:']], { origin: 'L3' });
      XLSX.utils.sheet_add_aoa(ws, [['Class:']], { origin: 'L4' });
      XLSX.utils.sheet_add_aoa(ws, [['Type:']], { origin: 'L5' });
      XLSX.utils.sheet_add_aoa(ws, [['Vendor:']], { origin: 'L6' });
      XLSX.utils.sheet_add_aoa(ws, [['Report Type:']], { origin: 'L7' });
      XLSX.utils.sheet_add_aoa(ws, [['Order Type:']], { origin: 'L8' });
      this.myHarrellsService.openOrdersModeSelected


      XLSX.utils.sheet_add_aoa(ws, [['']], { origin: 'M1' });
      XLSX.utils.sheet_add_aoa(ws, [[this.myHarrellsService.orderSOPNumberSelected]], { origin: 'M2' });
      XLSX.utils.sheet_add_aoa(ws, [[this.myHarrellsService.ordersItemNumberSelected]], { origin: 'M3' });
      XLSX.utils.sheet_add_aoa(ws, [[this.myHarrellsService.ordersClassSelected]], { origin: 'M4' });
      XLSX.utils.sheet_add_aoa(ws, [[this.myHarrellsService.ordersTypeSelected]], { origin: 'M5' });
      XLSX.utils.sheet_add_aoa(ws, [[this.myHarrellsService.ordersVendorSelected]], { origin: 'M6' });
      XLSX.utils.sheet_add_aoa(ws, [[this.myHarrellsService.openOrdersModeSelected]], { origin: 'M7' });
      XLSX.utils.sheet_add_aoa(ws, [[(this.myHarrellsService.openOrdersBillHoldSelected) ? "Bill & Hold" : "Regular"]], { origin: 'M8' });

      //send the file to the browser
      XLSX.utils.book_append_sheet(wb, ws, this.myHarrellsService.customerSelected);
      XLSX.writeFile(wb, this.myHarrellsService.customerSelected + ' orders.xlsx');

      this.displaySuccessAlert = true;
      this.successText = "Your report is being generated.  Please check your downloads folder for the file '" + this.myHarrellsService.customerSelected + " orders.xlsx'";
    }
    else {
      //summary report 

      for (let i = 0; i < this.openOrdersFiltered.length; i++) {
        xlarray.push({
          "Order#": this.openOrdersFiltered[i].SOPNumber,
          "Date": this.openOrdersFiltered[i].DocumentDate,
          "Status": this.openOrdersFiltered[i].Status,
          "Req_Ship": this.openOrdersFiltered[i].RequestedShipDate,
          "Ship_To": this.openOrdersFiltered[i].ShipToAddress,
          "City,State": this.openOrdersFiltered[i].CityState,
          "Total": ((this.myHarrellsService.loggedInMyHarrellsUser && this.myHarrellsService.loggedInMyHarrellsUser.RoleName.indexOf('ClientBasic') == -1)) ? this.openOrdersFiltered[i].ExtendedPrice.toFixed(2) : '',
        })
      }


      let wb = XLSX.utils.book_new();
      var ws = XLSX.utils.json_to_sheet(xlarray);

      //add filters to spreasheets in columns K and L
      XLSX.utils.sheet_add_aoa(ws, [['--FILTERS--']], { origin: 'L1' });
      XLSX.utils.sheet_add_aoa(ws, [['Order #:']], { origin: 'L2' });
      XLSX.utils.sheet_add_aoa(ws, [['Report Type:']], { origin: 'L3' });
      XLSX.utils.sheet_add_aoa(ws, [['Order Type:']], { origin: 'L4' });
      this.myHarrellsService.openOrdersModeSelected


      XLSX.utils.sheet_add_aoa(ws, [['']], { origin: 'M1' });
      XLSX.utils.sheet_add_aoa(ws, [[this.myHarrellsService.orderSOPNumberSelected]], { origin: 'M2' });
      XLSX.utils.sheet_add_aoa(ws, [[this.myHarrellsService.openOrdersModeSelected]], { origin: 'M3' });
      XLSX.utils.sheet_add_aoa(ws, [[(this.myHarrellsService.openOrdersBillHoldSelected) ? "Bill & Hold" : "Regular"]], { origin: 'M4' });

      //send the file to the browser
      XLSX.utils.book_append_sheet(wb, ws, this.myHarrellsService.customerSelected);
      XLSX.writeFile(wb, this.myHarrellsService.customerSelected + ' orders.xlsx');

      this.displaySuccessAlert = true;
      this.successText = "Your report is being generated.  Please check your downloads folder for the file '" + this.myHarrellsService.customerSelected + " orders.xlsx'";

    }
  }

  // #endregion

  // #region My Products

  SortMyProductsGrid(sortBy: string) {
    if (this.sortDir == "asc" || this.sortDir == "") {
      //sorting ascending
      if (sortBy == 'Item') {
        this.myProductsFiltered = this.myProductsFiltered.sort((a, b) => (a.ItemNumber > b.ItemNumber) ? 1 : -1)
      }
      else if (sortBy == 'Description') {
        this.myProductsFiltered = this.myProductsFiltered.sort((a, b) => (a.ProductDesc > b.ProductDesc) ? 1 : -1)
      }
      else if (sortBy == 'UofM') {
        this.myProductsFiltered = this.myProductsFiltered.sort((a, b) => (a.UofM > b.UofM) ? 1 : -1)
      }

      this.sortDir = 'desc';
    }
    else {
      //sorting descending
      if (sortBy == 'Item') {
        this.myProductsFiltered = this.myProductsFiltered.sort((a, b) => (a.ItemNumber > b.ItemNumber) ? -1 : 1)
      }
      else if (sortBy == 'Description') {
        this.myProductsFiltered = this.myProductsFiltered.sort((a, b) => (a.ProductDesc > b.ProductDesc) ? -1 : 1)
      }
      else if (sortBy == 'UofM') {
        this.myProductsFiltered = this.myProductsFiltered.sort((a, b) => (a.UofM > b.UofM) ? -1 : 1)
      }

      this.sortDir = 'asc';
    }
  }

  VendorFocusMyProducts() {
    this.CloseAllMyProductsDropdowns();

    this.showMyProductsVendorList = true;
  }

  FilterVendorMyProducts() {
    this.myProductsVendorListFiltered = this.myProductsVendorListMaster.filter(x => x.toLowerCase().indexOf(this.myProductsVendorSelected.toLowerCase()) > -1);
  }

  VendorSelectedMyProducts(vendor: any) {
    this.myProductsVendorSelected = vendor;
    this.showMyProductsVendorList = false;

    //reload dropdowns and grid
    this.FilterMyProducts();
  }

  ClassFocusMyProducts() {
    this.CloseAllMyProductsDropdowns();

    this.showMyProductsClassList = true;
  }

  FilterClassesMyProducts() {
    this.myProductsClassListFiltered = this.myProductsClassListMaster.filter(x => x.toLowerCase().indexOf(this.myProductsClassSelected.toLowerCase()) > -1);
  }

  ClassSelectedMyProducts(classSelected: any) {
    this.myProductsClassSelected = classSelected;
    this.showMyProductsClassList = false;

    //reload dropdowns and grid
    this.FilterMyProducts();

  }

  TypeFocusMyProducts() {
    this.CloseAllMyProductsDropdowns();

    this.showMyProductsTypeList = true;
  }

  FilterTypeMyProducts() {
    this.myProductsTypeListFiltered = this.myProductsTypeListMaster.filter(x => x.toLowerCase().indexOf(this.myProductsTypeSelected.toLowerCase()) > -1);
  }

  TypeSelectedMyProducts(type: any) {
    this.myProductsTypeSelected = type;
    this.showMyProductsTypeList = false;

    //reload dropdowns and grid
    this.FilterMyProducts();
  }

  //filter the myProducts grid based on vendor, class, and type selected
  FilterMyProducts() {

    this.myProductsFiltered = this.myProductsMaster;

    if (this.myProductsVendorSelected != "") {
      this.myProductsFiltered = this.myProductsFiltered.filter(x => x.Vendor.toLowerCase().indexOf(this.myProductsVendorSelected.toLowerCase()) > -1);
    }

    if (this.myProductsClassSelected != "") {
      this.myProductsFiltered = this.myProductsFiltered.filter(x => x.Class.toLowerCase().indexOf(this.myProductsClassSelected.toLowerCase()) > -1);
    }

    if (this.myProductsTypeSelected != "") {
      this.myProductsFiltered = this.myProductsFiltered.filter(x => x.Type.toLowerCase().indexOf(this.myProductsTypeSelected.toLowerCase()) > -1);
    }
  }

  MyProductsRowClicked(row: any) {
    if (this.selectedMyProductRowId == row.ItemNumber) {
      //hide the one that is showing 
      this.selectedMyProductRowId = "";
    }
    else {
      this.selectedMyProductRowId = row.ItemNumber;
      this.selectedProduct = row;
      this.selectedProductsActiveIngredients = [];
      this.selectedProduct.RegisteredStates = "";
      this.selectedProduct.PestName = "";

      //since we are just getting the product details, trim the zz if it is a bh item or the query wont find the details
      this.myHarrellsService.GetMyProductsProductDetail(row.ItemNumber).subscribe((data: any) => {
        if (data) {
          this.selectedProduct.RegisteredStates = data.RegisteredStates;
          this.selectedProduct.PackageInfo = (data.PackageInfo != "") ? data.PackageInfo : row.UofM;
          data.PestName = data.PestName.replaceAll(',', ', ');
          this.selectedProduct.PestName = data.PestName;

          if (data.ActiveIngredients) {
            for (let i = 0; i < data.ActiveIngredients.length; i++) {
              if (this.selectedProductsActiveIngredients.findIndex(x => x.Name == data.ActiveIngredients[i].Name) == -1) {
                this.selectedProductsActiveIngredients.push({ Name: data.ActiveIngredients[i].Name, Percentage: data.ActiveIngredients[i].Value });
              }
            }
          }
        }
        else {
          this.selectedProduct.PackageInfo = row.UofM;
        }
      })
    }
  }

  OpenCalculator() {
    window.open(this.appDomainURL + 'calculators', "_blank");
  }

  // #endregion

  DisplayMyHarrellsMenu() {
    this.displayMyHarrellsMobileMenu = !this.displayMyHarrellsMobileMenu;
  }

  CloseMyHarrellsMobileMenu() {
    this.displayMyHarrellsMobileMenu = false;
  }

  ToggleFilter() {
    this.showFilterObjects = !this.showFilterObjects;
  }

  GoToMatrix() {
    //this takes the logged in usre to their matrix page in a new tab
    //it first checks that they are in the matrix system and if not, creates the matrix account for them 
    this.router.navigate(['/matrix']);


    //this makes sure the tab they came from is still on the myHarrells page 
    setTimeout(() => {
      window.location.href = '/myharrells';
    }, 3000);


  }

  CloseAllOrdersDropdowns() {
    this.showOrdersItemNumberList = false;
    this.showOrdersSOPNumberList = false;
    this.showOrdersClassesList = false;
    this.showOrdersTypesList = false;
    this.showOrdersVendorsList = false;
  }

  CloseAllInvoicesDropdowns() {
    this.showInvoiceNumberList = false;
    this.showInvoicePOList = false;
    this.showInvoicesItemNumbersList = false;
    this.showInvoicesClassList = false;
    this.showInvoicesTypeList = false;
    this.showInvoicesVendorList = false;
  }
  CloseAllMyProductsDropdowns() {
    this.showMyProductsClassList = false;
    this.showMyProductsTypeList = false;
    this.showMyProductsVendorList = false;
  }

  OpenCreditsModal() {
    if (this.hasCredits) {
      //height and width of modal must be 40px larger than video to get that border
      //tht is why the css for the modal is 840x540px when the video tag itself is 800x500
      document.getElementById("creditsModal").style.display = "block";
    }
  }

  CloseCreditsModal() {
    document.getElementById("creditsModal").style.display = "none";
  }

  GetCustomersCredits() {
    return new Promise((resolve, reject) => {
      this.myHarrellsService.GetCustomersCredits().subscribe((data) => {
        if (data.length > 0) {
          this.hasCredits = true;

          this.credits = [];
          //format the dates
          for (let i = 0; i < data.length; i++) {
            let z = new Date(data[i].DocumentDate);
            data[i].DocumentDate = z.toLocaleDateString("en-US");
            data[i].DocumentDateYYYYMMDD = z.getFullYear() + ("0" + (z.getMonth() + 1)).slice(-2) + ("0" + z.getDate()).slice(-2)
            this.credits.push(data[i]);
          }


          this.credits = data;
          resolve('');
        }
        else {
          this.hasCredits = false;
          resolve('');
        }
      }, (error) => {
        this.hasCredits = false;
        resolve('');
      })
    })

  }

  SortCreditsGrid(sortBy: string) {
    if (this.sortDirCredits == "asc" || this.sortDirCredits == "") {
      //sorting ascending
      if (sortBy == 'SOPNumber') {
        this.credits = this.credits.sort((a, b) => (a.SOPNumber > b.SOPNumber) ? 1 : -1)
      }
      else if (sortBy == 'DocDescription') {
        this.credits = this.credits.sort((a, b) => (a.DocDescription > b.DocDescription) ? 1 : -1)
      }
      else if (sortBy == 'DocumentDate') {
        this.credits = this.credits.sort((a, b) => (a.DocumentDateYYYYMMDD > b.DocumentDateYYYYMMDD) ? 1 : -1)
      }
      else if (sortBy == 'CreditAmount') {
        this.credits = this.credits.sort((a, b) => (a.CreditAmount > b.CreditAmount) ? 1 : -1)
      }

      this.sortDirCredits = 'desc';
    }
    else {
      //sorting descending
      if (sortBy == 'SOPNumber') {
        this.credits = this.credits.sort((a, b) => (a.SOPNumber > b.SOPNumber) ? -1 : 1)
      }
      else if (sortBy == 'DocDescription') {
        this.credits = this.credits.sort((a, b) => (a.DocDescription > b.DocDescription) ? -1 : 1)
      }
      else if (sortBy == 'DocumentDate') {
        this.credits = this.credits.sort((a, b) => (a.DocumentDateYYYYMMDD > b.DocumentDateYYYYMMDD) ? -1 : 1)
      }
      else if (sortBy == 'CreditAmount') {
        this.credits = this.credits.sort((a, b) => (a.CreditAmount > b.CreditAmount) ? -1 : 1)
      }

      this.sortDirCredits = 'asc';
    }
  }

  CloseCustomerDD() {
    this.showCustomersList = false
  }

  CloseAddressDD() {
    this.showAddressList = false
  }

  GoToEBizPortal() {
    if (this.myHarrellsService.customerSelected != "") {
      //try to authenticate the user in ebiz
      this.myHarrellsService.EBizAutoSignIn().subscribe((data: any) => {
        if (data) {
          if (data.indexOf('~~~') < 10) {
            //error returned from ebiz, 
            //display the default ebiz login in a new tab
            window.open("https://connect.ebizcharge.net/harrellsllc", "_blank");
          }
          else {
            //if both the sid and internalid are returned, then open the ebiz portal in a new tab
            var urlToUse = "https://connect.ebizcharge.net/sso1.aspx?Sid=" + data.substring(data.indexOf('~~~') + 3) + "&Uid=" + data.substring(0, data.indexOf('~~~'));
            console.log(urlToUse)
            window.open(urlToUse, "_blank");

            //this makes sure the tab they came from is still on the myHarrells page 
            setTimeout(() => {
              window.location.href = '/myharrells';
            }, 3000);
          }
        }
        else {
          //open the ebiz portal in a new tab with no sid or uid
          window.open("https://connect.ebizcharge.net/harrellsllc", "_blank");

        }
      })
    }
    else {
      this.displayFailureAlert = true;
      this.failureText = "You must select a customer to access the Payment Portal.";
    }

  }
}




